import VideoSectionOne from "../components/common/video/video-section-one";
import BreadcrumbSection from "../components/team/breadcrumb-section";
import TeamSection from "../components/team/team-section";

export default function Team() {
	return (
		<>
			<BreadcrumbSection />
			<VideoSectionOne />
			<TeamSection />
		</>
	);
}
